interface LowHigh {
  low: number;
  high: number;
}

export interface Tvalues {
  activity?: LowHigh;
  systolic?: LowHigh;
  diastolic?: LowHigh;
  pulse?: LowHigh;
  glucose?: LowHigh;
  FVC?: LowHigh;
  FEV1?: LowHigh;
  PEF?: LowHigh;
  FEV1_FVC?: LowHigh;
  spo2?: LowHigh;
  weight?: LowHigh;
  temp?: LowHigh;
  steps?: LowHigh;
  sleep?: LowHigh;
}

export interface ThresholdInterface {
  _id?: string;
  breachType: "high" | "moderate";
  readingType: string;
  memberId: string;
  coordinator: string;
  assignmentOrigin?: String,
  value: Tvalues;
}

export interface ThresholdContextInterface {
  high: Tvalues;
  moderate: Tvalues;
}

export const thresholdContext: ThresholdContextInterface = {
  high: {},
  moderate: {}
};
